import * as React from 'react';
import { useEffect, useMemo, useRef } from 'react';
import { AppState } from '@app/store';
import { connect } from 'react-redux';
import { isIEDetect } from '@app/helpers/utils';
import { setTizerHeight } from '@app/store/sizes/actions';
import './style.scss';
import { TizerListProps } from './TizerListProps';
import { businessTizerIds, individualTizerIds } from '@app/constants/adv';
import { useSchmetterling } from '@app/hooks/useSchmetterling';

const mapStateToProps = (state: AppState) => ({
  headerHeight: state.sizes.headerHeight,
  tizerHeight: state.sizes.tizerHeight,
  catalogueType: state.catalogue.type,
});

declare global {
  interface Window {
    Schmetterling: {
      create: ({
        element,
        params,
        onError,
      }: {
        element: Element;
        params: {
          platform: string;
        };
        onError: (error: any) => void;
      }) => void;
    };
  }
}

const dispatchProps = {
  setTizerHeight,
};

const TizerList: React.FC<TizerListProps> = ({
  headerHeight,
  catalogueType,
  tizerHeight,
  setTizerHeight,
}) => {
  const wrapRef = useRef<HTMLDivElement>(null);

  useSchmetterling(useMemo(() => [catalogueType], [catalogueType]));

  useEffect(() => {
    if (wrapRef?.current && wrapRef.current.clientHeight !== tizerHeight) {
      setTimeout(() => {
        setTizerHeight(wrapRef.current?.clientHeight);
      }, 300);
    }
  }, [setTizerHeight, tizerHeight, catalogueType]);

  return (
    <div className="mos-catalog_tizer" aria-hidden="true">
      <div
        className="mos-catalog_position-sticky"
        style={{
          top: isIEDetect() ? 0 : headerHeight,
        }}
      >
        {catalogueType === 'uslugi' && (
          <div className="mos-catalog_tizer-wrap" ref={wrapRef}>
            {individualTizerIds.map((id) => {
              return (
                <div className="mos-catalog_tizer-block">
                  <div
                    className="mos-catalog_tizer-banner"
                    data-schmetterling-id={id}
                  />
                </div>
              );
            })}
          </div>
        )}
        {catalogueType === 'biznes' && (
          <div className="mos-catalog_tizer-wrap" ref={wrapRef}>
            {businessTizerIds.map((id) => {
              return (
                <div className="mos-catalog_tizer-block">
                  <div
                    className="mos-catalog_tizer-banner"
                    data-schmetterling-id={id}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const ConnectedTizerList = connect(mapStateToProps, dispatchProps)(TizerList);

export default ConnectedTizerList;
